import { Button } from "@/components/ui/button";
import { LogOut, Settings } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Outlet, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import useAuthStore from "@/store/authStore";
import { toast } from "sonner";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import GenericSideBar from "@/components/layout/GenericSideBar";
import { adminMenuItems } from "@/config/sidebarMenu";

export default function AdminLayout() {
  const { t, i18n } = useTranslation();
  // const language = useAppStore((state) => state.language);
  // const darkMode = useAppStore((state) => state.darkMode);
  // const setLanguage = useAppStore((state) => state.setLanguage);
  // const toggleDarkMode = useAppStore((state) => state.toggleDarkMode);
  const navigate = useNavigate();

  const user = { name: "Admin User", initials: "AU" };

  // const toggleLanguage = useCallback(() => {
  //   const newLanguage = language === "he" ? "en" : "he";
  //   setLanguage(newLanguage);
  //   i18n.changeLanguage(newLanguage);
  // }, [language, setLanguage, i18n]);

  const { logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/auth");
    } catch (error) {
      console.error("Logout failed:", error);
      toast.error(i18n.t("auth.logoutError"));
    }
  };

  return (
    <SidebarProvider>
      <div className="w-full flex h-screen">
        <GenericSideBar menuItems={adminMenuItems} />
        <div className="flex flex-col flex-1">
          <header className="flex items-center justify-between px-4 py-3 shadow-md bg-backgroundLight text-gray-800 dark:bg-gray-800 dark:text-white">
            <SidebarTrigger />
            <div className="flex items-center gap-3">
              <h1 className="text-lg font-semibold">smrt-menu Admin</h1>
            </div>
            <div className="flex gap-2 items-center">
              {/* <Button variant="ghost" size="sm" onClick={toggleDarkMode}>
                {darkMode ? <Sun size={18} /> : <Moon size={18} />}
              </Button> */}
              {/* <Button variant="ghost" size="sm" onClick={toggleLanguage}>
                🌍 {language}
              </Button> */}
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" className="rounded-full p-0 h-8 w-8">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white text-primary font-medium">
                      {user.initials}
                    </div>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-56">
                  <DropdownMenuItem className="font-medium">
                    {user.name}
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => navigate("/admin/profile")}>
                    <Settings size={16} className="mr-2 text-gray-500" />
                    {t("usermenu.settings")}
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    className="text-red-500"
                    onClick={handleLogout}
                  >
                    <LogOut size={16} className="mr-2" />
                    {t("sidebar.logout")}
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </header>
          <main className="flex-1 p-6 overflow-auto bg-gray-50 dark:bg-gray-900 text-primaryText dark:text-gray-200">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
